<template>
<div class="m-lottery-wheel">
  <div id="turnBox">
    <ul id="turnUl">
      <li
        v-for="(item,index) in activeObj.prizeData"
        :key="index"
        :style="{webkitTransform: 'rotate(' + -item.angle + 'deg)'}"
        :class="item.isU? 'act' : ''"
      >
       
        <div class="item-pic" v-bind:data-tips="item.giftId">
          <div class="item-name"><p v-html="item.giftName"></p></div>
          <div class="item"><img v-bind:src='"../images/lottery/" + item.giftId + ".jpg"' alt="" srcset=""></div>
        </div>
      </li>
    </ul>
    <div class="u-btn lottery-start"  @click="lotteryStart"></div>
  </div>

  <div class="lottery_info">
    <span>我的抽奖券：<b>{{ ~~ua.score }}</b> 张</span>
    <span class="reflash u-btn" @click="reflash" v-if="login"><span class="icon"></span>刷新</span>
    <div class="u-btn record" @click="getRecord" v-if="login"></div>
  </div>
</div>
</template>

<script>
  export default {
    data(){
      return {
        pIndex: 0, // 中奖物品的下标
        rotNum:  0, // 旋转圈数基数
        time: 5000, // 旋转时间
        timer: null, // 定时器
        oTurntable: '', // 旋转圆盘背景图
        type: 0, // 0 图片 1 汉字
        activeObj : {
          prizeData : []
        },
        busy : false,
        score : 0,
      }
    },
    props : {
      prize_list : {
        default : [],
      },
      ua : {
          default : ()=>{},
      },
      login : {
          default : 0,
      },   
    },  
    created() {
      var _this = this;
      this.prize_list.forEach((item, index) => {
        _this.activeObj.prizeData.push({
          giftId : item.giftId,
          giftName : item.giftName,
          isU : false,
        })
      });      
      this.activeObj.prizeData = this.autoRotate(this.activeObj.prizeData);
      this.score = ~~this.ua.score
    },
    //渲染完了
    mounted() {
      this.oTurntable = document.querySelector('#turnUl');
      // 过度中属性用时5s
      this.oTurntable.style.webkitTransition = 'transform ' + this.time / 1000 + 's ease';
    },
    methods:{
      //自动生成角度添加到数组上
      autoRotate(arr) {
        if (arr.length) {
          let len = arr.length;
          let base = 360 / len;
          arr.forEach((item, index) => {
            // 指的是某个奖品区域的中间 : base/2
            item.angle = 360 - (base / 2 + index * base);
          });
        }
        return arr;
      },
      lotteryStart (){
        var _this = this;

        //this.$score_update(this.ua.score - 1);

        if(_this.busy)return;
        if(_this.ua.score == 0)return _this.$toast('奖券不足');

        this.activeObj.prizeData.forEach((item, index) => {
          item.isU = false;
        });        
        this.startPlay();
      },
      // 点击开始,请求接口抽奖
      async startPlay(){

        var _this = this;

        if(!_this.login)return this.$mslogin.open();
        if(!_this.ua.areaId)return this.$bind();

        _this.busy = true;

        _this.$axios.post(_this.$global.ajax_url_map.draw)
        .then(res => {
          if(res.data.code == 0){
            _this.$score_update(this.ua.score - 1);
            _this.startBtn({
              giftId : res.data.data,
              name : res.data.data, 
            })
          }
          else{
            _this.$toast(res.data.message);
            _this.busy = false;
          }
        });
        
      },
      // 开始转动,通过奖项级别进行匹配:id 
      async startBtn(val) {
        const self = this
        self.activeObj.prizeData.forEach((i,d)=>{
          if(i.giftId == val.giftId){
            self.pIndex = d
          }
        })
        // 拿到相应的角度调旋转接口
        self.startrotate(self.activeObj.prizeData[self.pIndex].angle, () => {
          self.fulfillHandle(self.activeObj.prizeData[self.pIndex].giftName);
          //确定得奖DOM
          self.activeObj.prizeData[self.pIndex].isU = true;
          self.busy = false;
        });
      },

      //开始旋转 angle角度  complete回调成功函数
      startrotate(angle, complete) {
        // 相应的角度 + 满圈 只是在原角度多转了几圈 360 * 6
        let rotate = 2160 * (this.rotNum + 1) + angle;
        this.oTurntable.style.webkitTransform = 'rotate(' + rotate + 'deg)';
        clearTimeout(this.timer);
        // 设置5秒后停止旋转,处理接口返回的数据
        this.timer = setTimeout(() => {
          complete();
          this.rotNum++;
        }, this.time);
      },
      //得奖后的处理
      fulfillHandle(prizeName) {
        this.$toast('恭喜你抽中' + prizeName);        
      },     
      //自动换行
      autoWrap(str) {
        if (str.length > 5 && str.length <= 10) {
          str = str.substring(0, 5) + '<br/>' + str.substring(5, str.length);
        } else if (str.length > 10) {
          str = str.substring(0, 5) + '<br/>' + str.substring(5, 9) + '...';
        }
        return str;
      },
      getRecord(){
        let _this = this;

        if(!_this.login)return this.$mslogin.open();
        if(!_this.ua.areaId)return this.$bind();

        _this.$axios.get(_this.$global.ajax_url_map.draw_record,{
              params : {
                  pageindex : 1,
                  pagesize: 5,
                  source : 2,
              }          
        })
        .then(res => {
          if(res.data.code == 0){
            if(res.data.data.list.length == 0)return _this.$toast('暂无中奖记录');

            _this.$record_modal({
                list : res.data.data.list,
                allpages : Math.min(res.data.data.allPages,10),             
            });
          }
          else{
            _this.$toast(res.data.message);
          }
        });
      },
      reflash (){
        var self = this;
        this.$axios.post(this.$global.ajax_url_map.userinfo)
        .then(res => {
          self.$toast('刷新成功~');
          if(res.data.code == 0){
            self.$score_update(res.data.data.score);
          }
        });
      },
    }
  }
</script>

<style scoped>

.reflash{
    color: #957a61;
    text-decoration: underline;
}

.reflash .icon{
    display: inline-block;
    width: 23px;
    height: 19px;
    margin: 0 10px;
    padding-right: 0;
    background-image: url(../images/icon-reflash-ticket.png);
    vertical-align: sub;
}

@media screen and (min-device-width: 1025px){
  #turnBox {
    width: 545px;
    height: 545px;
    position: relative;
    overflow: hidden;
    margin-top: 30px;
  }

      .lottery-start {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      width: 121px;
      height: 121px;
      background-image: url(../images/btn-draw.png);      
      background-repeat: no-repeat;
      background-size: 100% auto;
      z-index: 3;
    }

    .lottery-start::after{
      display: block;
      content: '';
      position: absolute;
      left: 50%;
      top: -50px;
      width: 58px;
      height: 57px;
      transform: translateX(-50%);
      background-image: url(../images/icon-arrow-lottery.png);
    }
    
.lottery-start:hover{
  background-image: url(../images/btn-draw_hover.png);
}    

    ul {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;
      background-repeat: no-repeat;
      background-size: 100% auto;
    background-position: center center;
    background-image: url(../images/bg-lottery.png);      
    } 
    
      li {
        position: absolute;
        box-sizing: border-box;
        color: #7e250d;
        font-size: 0.3rem;
        top: 0pc;
        left: 0px;
        width: 100%;
        height: 100%;
        line-height: 20px;
        transform-origin: 50% 50%;
      }   
      
      .item-pic{
        position: absolute;
        top: 35px;
        left: 50%;      
        transform: translateX(-50%);      
      }

      .item-pic .item-name{
        display: flex;
        align-items: center;
        height: 30px;
        margin-bottom: 5px;
        font-size: 14px;
        text-align: center;
      }

      .item-pic .item-name p{
        width: 100%;
        text-align: center;
      }
      
      .item-pic .item{
        position: relative;
        width: 83px;
        height: 80px;
        margin: 0 auto;
        background-image: url(../images/bg-item.png);
      }

      .act .item-pic .item{
        background-image: url(../images/bg-item-act.png);
      }

      .item-pic img {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 46px;
        height: 46px;
        transform: translate(-50%,-50%);
      }      

  .lottery_info{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
  }

  .lottery_info span{
    color: #5c483c;
    padding-right: 20px;
  }

  .lottery_info span b{
    font-size: 18px;
    font-weight: 700;
    color: #89322f;
  }

  .u-btn.record{
    width: 118px;
    height: 31px;
    background-image: url(../images/btn-record.png);
  }

  .u-btn.record:hover{
    background-image: url(../images/btn-record_hover.png);
  }

  .reflash:hover .icon{
    background-image: url(../images/icon-reflash-ticket_hover.png);
  }

  .reflash:hover{
      color: #b57235;
  }

}

@media screen and (max-device-width: 1024px){
  #turnBox {
    width: 665px;
    height: 665px;
    margin: 30px auto 0;
    position: relative;
    overflow: hidden;
  }

      .lottery-start {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      width: 147px;
      height: 147px;
      background-image: url(../images/m/btn-draw.png);      
      background-repeat: no-repeat;
      background-size: 100% auto;
      z-index: 3;
    }

    .lottery-start::after{
      display: block;
      content: '';
      position: absolute;
      left: 50%;
      top: -70px;
      width: 70px;
      height: 69px;
      transform: translateX(-50%);
      background-image: url(../images/m/icon-arrow-lottery.png);
    }
    
.lottery-start:hover{
  background-image: url(../images/btn-draw_hover.png);
}    

    ul {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;
      background-repeat: no-repeat;
      background-size: 100% auto;
    background-position: center center;
    background-image: url(../images/m/bg-wheel.png);      
    } 
    
      li {
        position: absolute;
        box-sizing: border-box;
        color: #7e250d;
        font-size: 0.3rem;
        top: 0pc;
        left: 0px;
        width: 100%;
        height: 100%;
        line-height: 20px;
        transform-origin: 50% 50%;
      }   
      
      .item-pic{
        position: absolute;
        top: 42px;
        left: 50%;      
        transform: translateX(-50%);      
      }

      .item-pic .item-name{
        display: flex;
        align-items: center;
        height: 30px;
        margin-bottom: 5px;
        font-size: 24px;
        text-align: center;
      }

      .item-pic .item-name p{
        width: 100%;
        text-align: center;
      }
      
      .item-pic .item{
        position: relative;
        width: 92px;
        height: 89px;
        margin: 0 auto;
        background-image: url(../images/m/bg-item.png);
      }

      .act .item-pic .item{
        background-image: url(../images/m/bg-item-act.png);
      }

      .item-pic img {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 69px;
        height: 69px;
        transform: translate(-50%,-50%);
      }      

  .lottery_info{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    margin-bottom: 40px;
  }

  .lottery_info span{
    color: #5c483c;
    padding-right: 20px;
  }

  .lottery_info span b{
    font-size: 36px;
    font-weight: 700;
    color: #89322f;
  }

  .u-btn.record{
    width: 236px;
    height: 59px;
    background-image: url(../images/m/btn-record.png);
  }

.reflash .icon{
    width: 40px;
    height: 33px;
    background-image: url(../images/m/icon-reflash-ticket.png);
}  

}

</style>


// WEBPACK FOOTER //
// src/components/lottery.pc.vue